module.exports = __webpack_public_path__ + "img/compass.8d8c5ef9.svg";